/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";
export const protobufPackage = "api";
export var CompanyMembershipRole;
(function (CompanyMembershipRole) {
    CompanyMembershipRole["unknown"] = "unknown";
    CompanyMembershipRole["guest"] = "guest";
    CompanyMembershipRole["member"] = "member";
    CompanyMembershipRole["admin"] = "admin";
})(CompanyMembershipRole || (CompanyMembershipRole = {}));
export var SIMAPN;
(function (SIMAPN) {
    SIMAPN["APN_EMPTY"] = "APN_EMPTY";
    SIMAPN["APN_TWILIO_WIRELESS"] = "APN_TWILIO_WIRELESS";
    /**
     * APN_SUPER - This references the Twilio Super SIM
     * https://www.twilio.com/docs/iot/supersim
     */
    SIMAPN["APN_SUPER"] = "APN_SUPER";
})(SIMAPN || (SIMAPN = {}));
export var SMSMessageEnum;
(function (SMSMessageEnum) {
    SMSMessageEnum["SMS_UNKNOWN"] = "SMS_UNKNOWN";
    SMSMessageEnum["SMS_DOWNLOAD_TUNNEL_ANDROID"] = "SMS_DOWNLOAD_TUNNEL_ANDROID";
    SMSMessageEnum["SMS_DOWNLOAD_TUNNEL_IOS"] = "SMS_DOWNLOAD_TUNNEL_IOS";
})(SMSMessageEnum || (SMSMessageEnum = {}));
export var LifecycleStatus;
(function (LifecycleStatus) {
    LifecycleStatus["LIFECYCLE_STATUS_UNKNOWN"] = "LIFECYCLE_STATUS_UNKNOWN";
    LifecycleStatus["LIFECYCLE_STATUS_INSTALLED_PRIMARY"] = "LIFECYCLE_STATUS_INSTALLED_PRIMARY";
    LifecycleStatus["LIFECYCLE_STATUS_INSTALLED_BACKUP"] = "LIFECYCLE_STATUS_INSTALLED_BACKUP";
    LifecycleStatus["LIFECYCLE_STATUS_INACTIVE"] = "LIFECYCLE_STATUS_INACTIVE";
    LifecycleStatus["LIFECYCLE_STATUS_PROVISIONED"] = "LIFECYCLE_STATUS_PROVISIONED";
    LifecycleStatus["LIFECYCLE_STATUS_UNINSTALLED"] = "LIFECYCLE_STATUS_UNINSTALLED";
    LifecycleStatus["LIFECYCLE_STATUS_DEMO"] = "LIFECYCLE_STATUS_DEMO";
    /** LIFECYCLE_STATUS_TEST - For internal testing */
    LifecycleStatus["LIFECYCLE_STATUS_TEST"] = "LIFECYCLE_STATUS_TEST";
})(LifecycleStatus || (LifecycleStatus = {}));
export var ISPProduct;
(function (ISPProduct) {
    ISPProduct["IR_UNKNOWN"] = "IR_UNKNOWN";
    ISPProduct["IR_DEDICATED_FIBER"] = "IR_DEDICATED_FIBER";
    ISPProduct["IR_SHARED_FIBER"] = "IR_SHARED_FIBER";
    ISPProduct["IR_POINT_TO_POINT_WIRELESS"] = "IR_POINT_TO_POINT_WIRELESS";
    ISPProduct["IR_RESIDENTIAL_FIBER"] = "IR_RESIDENTIAL_FIBER";
    ISPProduct["IR_RESIDENTIAL_CABLE"] = "IR_RESIDENTIAL_CABLE";
    ISPProduct["IR_BUSINESS_CABLE"] = "IR_BUSINESS_CABLE";
})(ISPProduct || (ISPProduct = {}));
export var ISPStatus;
(function (ISPStatus) {
    ISPStatus["IS_UNKNOWN"] = "IS_UNKNOWN";
    ISPStatus["IS_PRIMARY"] = "IS_PRIMARY";
    ISPStatus["IS_BACKUP"] = "IS_BACKUP";
})(ISPStatus || (ISPStatus = {}));
export var AccessPointStatus;
(function (AccessPointStatus) {
    AccessPointStatus["access_point_status_unknown"] = "access_point_status_unknown";
    AccessPointStatus["draft"] = "draft";
    AccessPointStatus["offline"] = "offline";
    AccessPointStatus["online"] = "online";
})(AccessPointStatus || (AccessPointStatus = {}));
export var InventoryStatus;
(function (InventoryStatus) {
    InventoryStatus["inventory_status_unknown"] = "inventory_status_unknown";
    InventoryStatus["in_stock"] = "in_stock";
    InventoryStatus["ready_for_install"] = "ready_for_install";
})(InventoryStatus || (InventoryStatus = {}));
export var RadioBand;
(function (RadioBand) {
    RadioBand["RB_UNKNOWN"] = "RB_UNKNOWN";
    RadioBand["RB_2G"] = "RB_2G";
    RadioBand["RB_5G"] = "RB_5G";
})(RadioBand || (RadioBand = {}));
/**
 * DeploymentStatus represents the status of a Deployment.
 * https://docs.aws.amazon.com/sdk-for-go/api/service/greengrass/#GetDeploymentStatusOutput
 */
export var DeploymentStatus;
(function (DeploymentStatus) {
    DeploymentStatus["DS_UNKNOWN"] = "DS_UNKNOWN";
    DeploymentStatus["DS_IN_PROGRESS"] = "DS_IN_PROGRESS";
    DeploymentStatus["DS_BUILDING"] = "DS_BUILDING";
    DeploymentStatus["DS_SUCCESS"] = "DS_SUCCESS";
    DeploymentStatus["DS_FAILURE"] = "DS_FAILURE";
})(DeploymentStatus || (DeploymentStatus = {}));
export var RecordType;
(function (RecordType) {
    RecordType["RT_UNKNOWN"] = "RT_UNKNOWN";
    RecordType["RT_DNSMASQ_LEASE"] = "RT_DNSMASQ_LEASE";
    RecordType["RT_DHCP_LOG"] = "RT_DHCP_LOG";
    RecordType["RT_CORE_DUMP"] = "RT_CORE_DUMP";
})(RecordType || (RecordType = {}));
/** TODO APPENG-362: Deprecate entire enum */
export var UserRole;
(function (UserRole) {
    UserRole["UR_MEMBER"] = "UR_MEMBER";
    UserRole["UR_GUEST"] = "UR_GUEST";
    UserRole["UR_ADMIN"] = "UR_ADMIN";
})(UserRole || (UserRole = {}));
export var ControllerEventType;
(function (ControllerEventType) {
    ControllerEventType["CE_UNKNOWN"] = "CE_UNKNOWN";
    ControllerEventType["CE_CREATED"] = "CE_CREATED";
    ControllerEventType["CE_ONLINE"] = "CE_ONLINE";
    ControllerEventType["CE_OFFLINE"] = "CE_OFFLINE";
    ControllerEventType["CE_DEGRADED"] = "CE_DEGRADED";
})(ControllerEventType || (ControllerEventType = {}));
export var AccessPointEventType;
(function (AccessPointEventType) {
    AccessPointEventType["AE_UNKNOWN"] = "AE_UNKNOWN";
    AccessPointEventType["AE_CREATED"] = "AE_CREATED";
    AccessPointEventType["AE_OFFLINE"] = "AE_OFFLINE";
    AccessPointEventType["AE_ONLINE"] = "AE_ONLINE";
    AccessPointEventType["AE_DEGRADED"] = "AE_DEGRADED";
})(AccessPointEventType || (AccessPointEventType = {}));
export var SSHUser;
(function (SSHUser) {
    SSHUser["SU_UNKNOWN"] = "SU_UNKNOWN";
    SSHUser["SU_SUPPORT"] = "SU_SUPPORT";
    SSHUser["SU_ADMIN"] = "SU_ADMIN";
    SSHUser["SU_ROOT"] = "SU_ROOT";
})(SSHUser || (SSHUser = {}));
export var BuildingContactType;
(function (BuildingContactType) {
    BuildingContactType["unknown_building_contact_type"] = "unknown_building_contact_type";
    BuildingContactType["property_manager"] = "property_manager";
    BuildingContactType["riser_manager"] = "riser_manager";
    BuildingContactType["self"] = "self";
    BuildingContactType["other"] = "other";
})(BuildingContactType || (BuildingContactType = {}));
export var ContentFilterAction;
(function (ContentFilterAction) {
    ContentFilterAction["CONTENTFILTER_ACTION_UNKNOWN"] = "CONTENTFILTER_ACTION_UNKNOWN";
    ContentFilterAction["CONTENTFILTER_ACTION_ALLOW"] = "CONTENTFILTER_ACTION_ALLOW";
    ContentFilterAction["CONTENTFILTER_ACTION_BLOCK"] = "CONTENTFILTER_ACTION_BLOCK";
})(ContentFilterAction || (ContentFilterAction = {}));
export var MaintenanceWindowRecurrence;
(function (MaintenanceWindowRecurrence) {
    MaintenanceWindowRecurrence["RECURRENCE_UNSPECIFIED"] = "RECURRENCE_UNSPECIFIED";
    MaintenanceWindowRecurrence["RECURRENCE_WEEKLY"] = "RECURRENCE_WEEKLY";
    MaintenanceWindowRecurrence["RECURRENCE_DAILY"] = "RECURRENCE_DAILY";
})(MaintenanceWindowRecurrence || (MaintenanceWindowRecurrence = {}));
export var FirmwareUpdateStatus;
(function (FirmwareUpdateStatus) {
    FirmwareUpdateStatus["FIRMWARE_UPDATE_STATUS_UNSPECIFIED"] = "FIRMWARE_UPDATE_STATUS_UNSPECIFIED";
    FirmwareUpdateStatus["FIRMWARE_UPDATE_STATUS_PENDING"] = "FIRMWARE_UPDATE_STATUS_PENDING";
    FirmwareUpdateStatus["FIRMWARE_UPDATE_STATUS_SUCCESS"] = "FIRMWARE_UPDATE_STATUS_SUCCESS";
    FirmwareUpdateStatus["FIRMWARE_UPDATE_STATUS_ERROR"] = "FIRMWARE_UPDATE_STATUS_ERROR";
})(FirmwareUpdateStatus || (FirmwareUpdateStatus = {}));
/** TODO APPENG-362: Deprecate this */
export var CompanyMembership_Role;
(function (CompanyMembership_Role) {
    CompanyMembership_Role["unknown"] = "unknown";
    CompanyMembership_Role["guest"] = "guest";
    CompanyMembership_Role["member"] = "member";
    CompanyMembership_Role["admin"] = "admin";
})(CompanyMembership_Role || (CompanyMembership_Role = {}));
export var HardwareDevice_Type;
(function (HardwareDevice_Type) {
    HardwareDevice_Type["UNKNOWN"] = "UNKNOWN";
    HardwareDevice_Type["CONTROLLER"] = "CONTROLLER";
    HardwareDevice_Type["SWITCH"] = "SWITCH";
    HardwareDevice_Type["ACCESS_POINT"] = "ACCESS_POINT";
})(HardwareDevice_Type || (HardwareDevice_Type = {}));
if (_m0.util.Long !== Long) {
    _m0.util.Long = Long;
    _m0.configure();
}
